import { init as initApm } from "@elastic/apm-rum";
import { isProduction, isAdmin } from "shared/utils/env";

const apm = initApm({
  environment: isProduction ? "production" : "staging",
  pageLoadTransactionName: window.location.pathname,
  serviceVersion: process.env.REACT_APP_SERVICE_VERSION,
  serviceName: isAdmin ? "admin" : "partner",
  serverUrl: document.location.origin,
  active: isProduction,
});

export default apm;
